import { type CartItem, type DiscountDTO } from 'ecosystem'
import { getProductDiscountPrice } from 'shared-utils'

export const applyDiscountToCart = (cartItems: CartItem[], discountCode: DiscountDTO) => {
  return cartItems.map((cartItem) => {
    if (cartItem.type === 'SINGLE') {
      const discount = getProductDiscountPrice(cartItem.meta.singleType.product, discountCode)

      if (discount) {
        return {
          ...cartItem,
          meta: {
            singleType: {
              ...cartItem.meta.singleType,
              product: {
                ...cartItem.meta.singleType.product,
                price: discount.discountedPrice,
                priceWithoutVat: discount.discountedPriceWithoutVat
              }
            }
          }
        }
      }

      return cartItem
    }

    const updatedItems = cartItem.meta.groupType.items.map((groupItem) => {
      const discount = getProductDiscountPrice(groupItem.product, discountCode)

      if (discount) {
        return {
          ...groupItem,
          product: {
            ...groupItem.product,
            price: discount.discountedPrice,
            priceWithoutVat: discount.discountedPriceWithoutVat
          }
        }
      }

      return groupItem
    })

    return {
      ...cartItem,
      meta: {
        groupType: {
          ...cartItem.meta.groupType,
          items: updatedItems
        }
      }
    }
  })
}
